import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairportcorporatecabservice() {



  const cardData =
  {
    keyword: ' Mumbai Airport Corporate Cab Services',
    heading: 'Pune Corporate Cars India Private Limited: Mumbai Airport Corporate Cab Services',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Mumbai Airport Corporate Cab Services, ensuring smooth and timely transportation for business travelers, employees, clients, and VIPs arriving at or departing from Chhatrapati Shivaji Maharaj International Airport. Our fleet of well-maintained sedans, SUVs, MUVs, and premium vehicles guarantees safe, comfortable, and hassle-free travel to major corporate hubs, IT parks, industrial zones, and business districts across Mumbai. Whether it is airport pickups, hotel transfers, inter-office travel, corporate meetings, or VIP movement, we deliver punctual and seamless mobility solutions. With trained chauffeurs, GPS-enabled vehicles, flexible billing plans, and 24×7 service support, Pune Corporate Cars India Private Limited ensures a dependable and premium airport travel experience for businesses operating in and around Mumbai.',

    top: 'Top Places to Visit in Mumbai with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Bandra Kurla Complex (BKC)",
      "description": "Bandra Kurla Complex is Mumbai’s premier financial and commercial district, home to multinational corporations, consulates, global banks, Fortune 500 headquarters, and luxury business hotels. The area includes iconic business towers such as Jio World Centre, Naman Chambers, and The Capital. BKC is the top hotspot for corporate meetings, high-profile events, executive travel, and airport transfers—making it one of the busiest destinations for corporate cab services."
    },
    {
      "title": "Lower Parel Corporate Hub",
      "description": "Lower Parel is Mumbai’s most dynamic corporate zone, combining high-rise office towers like One Indiabulls Centre, Peninsula Business Park, and Lodha World Towers. The area is filled with premium coworking spaces, studios, business hotels, and award-winning restaurants. With its mix of creative agencies, finance companies, and MNCs, Lower Parel demands fast, reliable corporate commuting throughout the day."
    },
    {
      "title": "Nariman Point Business District",
      "description": "Nariman Point is one of India’s oldest and most prestigious business districts, housing corporate headquarters, legal firms, government offices, and international consulates. Overlooking the Marine Drive seafront, it contains iconic commercial towers like Air India Building and Maker Chambers. High-density office traffic makes Nariman Point a prime route for corporate cab travel, especially during peak office hours."
    },
    {
      "title": "Andheri MIDC & SEEPZ",
      "description": "Andheri MIDC and SEEPZ SEZ are major industrial and tech zones in Mumbai, home to IT companies, export houses, manufacturing units, and global service providers. With thousands of employees working across multiple shifts, this zone witnesses high demand for employee transportation, shift-based staff travel, and corporate shuttle services throughout the day."
    },
    {
      "title": "Goregaon Nesco Business Park",
      "description": "Nesco IT Park in Goregaon East has become a major commercial destination with modern office towers, convention centers, and large corporate campuses. It hosts companies in IT, finance, BFSI, and media industries. Its proximity to the Western Express Highway and large employee base makes it one of the most active hubs for corporate cab requirements and executive travel."
    },
    {
      "title": "Powai Hiranandani Business District",
      "description": "Powai’s Hiranandani Business Park is a premium corporate environment featuring modern office complexes, luxury residences, and scenic surroundings. It hosts companies like Nomura, CRISIL, Deloitte, and JP Morgan. The area is known for high-end corporate travel, airport pickups, client meeting routes, and executive chauffeur services due to its professional working crowd."
    },
    {
      "title": "Vikhroli Godrej Business District",
      "description": "Vikhroli is home to the massive Godrej Business Park along with multiple commercial towers, IT campuses, and research facilities. Surrounded by greenery and located close to eastern business zones, it is a preferred location for tech firms and innovation centers. The daily movement of employees and corporate visitors creates consistent demand for premium mobility services."
    },
    {
      "title": "Andheri East Corporate Zone",
      "description": "Andheri East is Mumbai’s largest corporate cluster, packed with commercial towers like Solitaire Corporate Park, Ackruti Star, Times Square, and Hubtown Solaris. Its strategic location near Mumbai Airport makes it a hotspot for business travelers, frequent flyers, and client visits. Corporate cab services play a crucial role in daily commutes, airport drops, and inter-office travel."
    },
    {
      "title": "Malad Mindspace IT Park",
      "description": "Mindspace Malad is one of Mumbai’s biggest IT parks, hosting thousands of professionals working in tech, BPO, and corporate services. With companies like Amazon, Accenture, and JP Morgan operating here, the area runs round-the-clock mobility needs including daily office travel, night shift employee transportation, and executive cab services."
    },
    {
      "title": "Thane Ghodbunder Corporate Belt",
      "description": "Ghodbunder Road in Thane has rapidly grown into a major business corridor with IT parks, commercial complexes, and premium office towers. Corporate hubs like G:Corp, Orion Business Park, and TCS Olympus Centre bring huge employee footfall. It is well-connected to Mumbai, Navi Mumbai, and Thane, making it a high-demand route for corporate taxi and staff transportation services."
    }
  ],


"services": [
{
"name": "Corporate Airport Transfer Mumbai",
"description": "Corporate Airport Transfer Mumbai provides professional and reliable airport transportation services for corporate clients and office staff. The service includes trained chauffeurs, GPS-enabled vehicles, structured routes, and timely pickups and drop-offs, ensuring safe, comfortable, and efficient travel to and from Mumbai airports."
},
{
"name": "Mumbai Airport Pickup Drop",
"description": "Mumbai Airport Pickup Drop offers dependable daily airport transfer services for employees, executives, and business travelers. The service features well-maintained vehicles, professional drivers, GPS tracking, and punctual pickups to guarantee stress-free and convenient airport commuting."
},
{
"name": "Airport Staff Shuttle Mumbai",
"description": "Airport Staff Shuttle Mumbai delivers organized shuttle services for corporate staff and employees traveling to and from Mumbai airports. With multi-passenger vehicles, trained drivers, GPS-enabled monitoring, and structured routes, the service ensures efficient, safe, and timely transportation."
},
{
"name": "Business Airport Taxi Mumbai",
"description": "Business Airport Taxi Mumbai provides professional corporate taxi services for executives, office staff, and business travelers. The service ensures punctual pickups, trained chauffeurs, GPS-enabled vehicles, and optimized routes for comfortable and reliable airport travel."
},
{
"name": "Executive Airport Cab Mumbai",
"description": "Executive Airport Cab Mumbai offers premium airport transportation services for corporate executives and VIP clients. The service includes luxury sedans and SUVs, trained drivers, GPS tracking, and timely airport pickups and drop-offs for a seamless and professional travel experience."
},
{
"name": "Monthly Airport Transport Mumbai",
"description": "Monthly Airport Transport Mumbai provides long-term airport commuting solutions for companies requiring consistent employee transfers. The service includes fixed monthly plans, professional drivers, GPS-enabled vehicles, structured schedules, and optimized routes for safe, efficient, and hassle-free airport transportation."
},
{
"name": "Best Corporate Airport Cab Mumbai",
"description": "Best Corporate Airport Cab Mumbai offers top-quality airport transfer services for corporate employees, executives, and business travelers. The service features well-maintained sedans and SUVs, trained chauffeurs, GPS tracking, structured routes, and punctual pickups to ensure reliable and comfortable airport commuting."
},
{
"name": "Employee Airport Commute Mumbai",
"description": "Employee Airport Commute Mumbai delivers organized airport transportation for office staff and industrial employees. The service includes professional drivers, GPS-enabled vehicles, optimized routes, and timely pickups to ensure safe, convenient, and stress-free commuting to and from Mumbai airports."
},
{
"name": "Airport Fleet Provider Mumbai",
"description": "Airport Fleet Provider Mumbai offers comprehensive corporate fleet solutions for airport transfers. The service includes sedans, SUVs, and staff cabs, along with driver management, GPS tracking, vehicle maintenance, and structured schedules for efficient and reliable airport commuting."
},
{
"name": "Outstation Airport Cab Mumbai",
"description": "Outstation Airport Cab Mumbai provides long-distance and intercity airport transportation solutions for corporate employees and business travelers. The service includes trained chauffeurs, GPS-enabled vehicles, optimized routes, and comfortable seating for safe, punctual, and hassle-free travel."
},
{
"name": "Sedan Airport Cab Mumbai",
"description": "Sedan Airport Cab Mumbai offers premium sedans for airport transfers, corporate travel, and executive commuting. The service ensures punctual pickups, professional drivers, GPS tracking, and well-maintained vehicles for a comfortable and professional travel experience."
},
{
"name": "SUV Airport Cab Mumbai",
"description": "SUV Airport Cab Mumbai provides spacious and comfortable SUVs suitable for team travel, corporate staff, and long-distance airport transfers. The service includes trained drivers, GPS-enabled vehicles, structured routes, and timely pickups for safe and reliable commuting."
},
{
"name": "Airport Corporate Travel Mumbai",
"description": "Airport Corporate Travel Mumbai delivers professional transportation services for executives, office staff, and corporate teams traveling to and from airports. The service features trained chauffeurs, GPS-monitored vehicles, structured routes, and timely pickups to ensure seamless and comfortable airport travel."
},
{
"name": "Company Airport Transport Mumbai",
"description": "Company Airport Transport Mumbai provides dedicated airport commuting solutions for companies and their employees. The service includes well-maintained vehicles, trained drivers, GPS tracking, structured schedules, and punctual pickups to ensure safe, efficient, and reliable airport transport."
},
{
"name": "Airport Chauffeur Service Mumbai",
"description": "Airport Chauffeur Service Mumbai offers premium chauffeur-driven airport transfer services for executives, VIPs, and corporate clients. The service includes luxury sedans and SUVs, trained professional drivers, GPS-enabled monitoring, and punctual pickups for a seamless and comfortable travel experience."
}
],

"tableData": [
["Corporate Airport Transfer Mumbai", "Mumbai Airport Pickup Drop"],
["Airport Staff Shuttle Mumbai", "Business Airport Taxi Mumbai"],
["Executive Airport Cab Mumbai", "Monthly Airport Transport Mumbai"],
["Best Corporate Airport Cab Mumbai", "Employee Airport Commute Mumbai"],
["Airport Fleet Provider Mumbai", "Outstation Airport Cab Mumbai"],
["Sedan Airport Cab Mumbai", "SUV Airport Cab Mumbai"],
["Airport Corporate Travel Mumbai", "Company Airport Transport Mumbai"],
["Airport Chauffeur Service Mumbai", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Powai MIDC Mumbai",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Powai MIDC Mumbai, ensuring smooth, safe, and timely transportation for business employees and executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs, helping professionals reach offices, industrial zones, and business hubs in Powai MIDC Mumbai without any delays."
  },
  {
    "WhyChooseheading": "Skilled & Professional Drivers",
    "WhyChoosedescription": "Our trained chauffeurs deliver safe, courteous, and disciplined travel, ensuring a comfortable and secure commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Select from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained to offer safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Tailored Corporate Travel Packages",
    "WhyChoosedescription": "We provide flexible cab rental plans designed to meet the specific commuting needs of businesses and employees in Powai MIDC Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Support for Corporate Travel",
    "WhyChoosedescription": "Our team is available round-the-clock for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Easy Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is streamlined with our simple booking process and efficient coordination, making employee transportation hassle-free."
  }
]























  }

const faqData = [
  {
    question: 'Do you provide corporate cab services for Mumbai Airport transfers?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate airport cab services for executives and employees traveling to and from Mumbai Airport.',
  },
  {
    question: 'What types of corporate airport cab services are available?',
    answer: 'We provide airport pickups, drop-offs, round-trip services, VIP transfers, and dedicated corporate airport travel solutions.',
  },
  {
    question: 'Do you offer timely airport transfers for corporate clients?',
    answer: 'Yes, our corporate cab services ensure punctual airport pickups and drops with real-time tracking and optimized routes.',
  },
  {
    question: 'How can companies book airport corporate cab services?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for airport corporate cab services?',
    answer: 'We offer sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on corporate requirements and passenger count.',
  },
  {
    question: 'Can multiple vehicles be booked for group airport transfers?',
    answer: 'Yes, Pune Corporate Cars India Private Limited can provide multiple vehicles for transporting large teams or VIP groups to and from the airport.',
  },
  {
    question: 'Are chauffeurs provided for airport corporate cab services?',
    answer: 'Absolutely. All airport cab services come with professional, trained chauffeurs to ensure a safe and comfortable ride.',
  },
  {
    question: 'What safety measures are followed for airport cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by verified and experienced drivers.',
  },
  {
    question: 'What payment options are available for corporate airport cab services?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide corporate invoicing for business clients.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Verma',
    feedback: 'Mumbai Airport transfers through Pune Corporate Cars India Private Limited are extremely professional and punctual. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Deshpande',
    feedback: 'Reliable and comfortable corporate airport cab service. The drivers are professional and vehicles are top-notch.',
    rating: 5,
  },
];





























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport Corporate Cab Services",
  "image": "https://www.punecorporatecars.com/assets/images/mumbai-airport-corporate-cab.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited offers premium Mumbai Airport Corporate Cab Services including corporate airport transfers, airport pickup & drop, business travel taxis, staff shuttle services, monthly airport transportation, executive chauffeur-driven cars, and reliable fleet services for companies and employees traveling via Mumbai International Airport.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/mumbai-airport-corporate-cab-services"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai Airport Corporate Cab Services | Business & Executive Transfers</title>

  <meta
    name="description"
    content="Premium Mumbai Airport corporate cab services including business airport transfers, staff shuttle services, airport pickup & drop, monthly airport transport, executive chauffeur-driven cars, outstation airport cabs, and reliable corporate fleet services for companies in Mumbai."
  />

  <meta
    name="keywords"
    content="Corporate Airport Transfer Mumbai, Mumbai Airport Pickup Drop, Airport Staff Shuttle Mumbai, Business Airport Taxi Mumbai, Executive Airport Cab Mumbai, Monthly Airport Transport Mumbai, Best Corporate Airport Cab Mumbai, Employee Airport Commute Mumbai, Airport Fleet Provider Mumbai, Outstation Airport Cab Mumbai, Sedan Airport Cab Mumbai, SUV Airport Cab Mumbai, Airport Corporate Travel Mumbai, Company Airport Transport Mumbai, Airport Chauffeur Service Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairportcorporatecabservice;